import {
  Badge,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { IProduct } from '@tyrio/dto';
import { useVehicleCtx } from '../../../../../context/VehicleContext';
import { toString } from 'lodash';
import { useContext } from 'react';
import { POSDetailsContext } from '../../../../../context/POSDetails';

export const Dropdown = ({
  label,
  value,
  onChange,
  menuItems,
  width,
  hasBadge,
}: {
  label: string;
  value: string | undefined;
  onChange: (value: string) => void;
  menuItems: { label: string; value: string; showBadge?: boolean }[];
  width?: string;
  hasBadge?: boolean;
}) => {
  return (
    <FormControl style={{ width }}>
      <InputLabel id="rim-size-label">{label}</InputLabel>
      <Select
        fullWidth
        labelId="rim-size-label"
        id="rim-size"
        value={value}
        label={label}
        onChange={({ target: { value } }) => {
          onChange(value);
        }}
      >
        {menuItems.map((item) => {
          return (
            <MenuItem value={item.value} key={item.value}>
              {item.showBadge && hasBadge && (
                <Badge
                  color="success"
                  variant="dot"
                  sx={{ marginRight: '5px' }}
                />
              )}
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export const ProductDropdown = ({ products }: { products?: IProduct[] }) => {
  const { setSelectedProduct, selectedProduct, stockListProductIds } =
    useVehicleCtx();

  const { setIsFetchingSupplierStock, setIsFetchingBranchStock } =
    useContext(POSDetailsContext);
  const onStock = (uid: string) => {
    const item = (stockListProductIds ?? []).find((p) => p === uid);
    return item !== undefined;
  };

  return (
    <Dropdown
      label="Choose rim size"
      value={toString(selectedProduct?.uid)}
      onChange={(value) => {
        setIsFetchingSupplierStock(true);
        setIsFetchingBranchStock(true);
        setSelectedProduct(products?.find((f) => f.uid === value) ?? null);
      }}
      width={'100%'}
      menuItems={
        (products ?? []).map((e) => {
          const showBadge = onStock(e.uid) ?? false;

          return { label: e.productName, value: e.uid, showBadge };
        }) ?? []
      }
      hasBadge={true}
    />
  );
};

export const EtDropdown = () => {
  const { selectedProduct, setSelectedEt, selectedEt } = useVehicleCtx();
  const { setIsFetchingBranchStock, setIsFetchingSupplierStock } =
    useContext(POSDetailsContext);

  if (selectedProduct?.et && selectedProduct?.et?.length > 1)
    return (
      <Dropdown
        label="ET"
        value={toString(selectedEt)}
        onChange={(value) => {
          setIsFetchingBranchStock(true);
          setIsFetchingSupplierStock(true);
          setSelectedEt(Number(value));
        }}
        width="20%"
        menuItems={(selectedProduct?.et ?? []).map((e) => {
          return { label: e.toString(), value: e.toString() };
        })}
      />
    );
  else return null;
};
